import React, { useState } from 'react';
import './RegisterPage.scss';
import { CircularProgress } from '@mui/material';
import { NavLink, Navigate } from 'react-router-dom';
import { registerUser } from '../../data/api';
import { Bounce, ToastContainer, toast } from 'react-toastify';


export const RegisterPage = () => {
    const [email, setEmail] = useState('');
    const [repeatEmail, setRepeatEmail] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [registrationSuccess, setRegistrationSuccess] = useState(false); // Estado para mostrar el mensaje de registro exitoso

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Verifica que los correos y contraseñas sean iguales
        if (email !== repeatEmail) {
            toast.error('Los correos electrónicos no coinciden', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            return;
        }
        if (password !== repeatPassword) {
            toast.error('Las contraseñas no coinciden', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            return;
        }

        if (password.length < 6) {
            toast.error('La contraseña debe contener mínimo 6 caracteres', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            return;
        }

        // Simulación de solicitud al servidor con un retraso de 1 segundo
        setIsLoading(true);
        const resp = await registerUser(email, password);
        if (resp.status === 'success') {
            // Usuario registrado
            setRegistrationSuccess(true); // Establece el estado de registro exitoso a true
        } else {
            // No se puede registrar
            console.log(resp.error);
            toast.error(resp.error, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
        }

        setIsLoading(false);
    };

    return (
        <div className='register-background'>
            {
                registrationSuccess ? (
                <div className="registration-success">
                    <h3>Registro exitoso</h3>
                    <p>Hemos enviado un correo de verificación a <b>{email}</b>. <br/>Revise su bandeja de entrada para completar el registro. <br/>No olvide revisar la pestaña de spam.</p>
                </div>
            ) 
            :
            (<div className='register-container'>
                <img className='register-img' src={require("../../assets/utn-logo-black.png")} alt="UTN Logo"/>
                <form className='register-form' onSubmit={handleSubmit}>
                    <input 
                        type='email' 
                        id='mail' 
                        placeholder='Correo electrónico' 
                        required
                        pattern={email ? `^${email.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$` : '.*'}
                        title='Los correos electrónicos no coinciden'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input 
                        type='email' 
                        id='mail2' 
                        placeholder='Repetir correo electrónico' 
                        required
                        pattern={email ? `^${email.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$` : '.*'}
                        title='Los correos electrónicos no coinciden'
                        value={repeatEmail}
                        onChange={(e) => setRepeatEmail(e.target.value)}
                    />
                    <input 
                        type='password' 
                        id='password' 
                        placeholder='Contraseña' 
                        required
                        pattern={password ? `^${password.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$` : '.*'}
                        title='Las contraseñas no coinciden'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input 
                        type='password' 
                        id='password2' 
                        placeholder='Repetir contraseña' 
                        required
                        pattern={password ? `^${password.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$` : '.*'}
                        title='Las contraseñas no coinciden'
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    />
                    {isLoading ? <CircularProgress style={{margin:'10px auto'}}/> : <button className='register-form-btn' type='submit'>Registrarse</button>}
                    <p>¿Ya tienes una cuenta? <NavLink to='/' className='login-text'>Inicia sesión</NavLink></p>
                </form>
            </div>)
            }
            
        <ToastContainer
            position="bottom-right"
            autoClose={5000}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="dark"
            transition={Bounce}
            />
        </div>
    );
};
